import { QuestionErrorMessage } from '@nextiva/engagement-ui';
import withClassName from '../../../utils/withClassName';

import styles from './QuestionErrorMessage.scss';

export default withClassName(styles.errorMessage)(QuestionErrorMessage);
